import {
  collection,
  getFirestore,
  query,
} from 'firebase/firestore';

export default function getAllOrgsQuery() {
  return query(collection(getFirestore(), 'organizations'));
}
